import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { useState } from 'react';
import logo from '../../assets/aba/logo-aba.png'
import { useTranslation } from 'react-i18next';
import flagEsp from '../../assets/logos/espana.png';
import flagUsa from '../../assets/logos/estados-unidos.png';
import flagChina from '../../assets/logos/china.png';

function ModalWelcome() {

    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);

    const { i18n, t } = useTranslation()

    return (
        <Container>
            <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>{t('welcome')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <Row>
                <hr/>
                <Col md={12} style={{ textAlign: 'center'}}>
                  <img
                      src={logo}
                      width="10px"
                      height="200px"
                      alt="Aba logo"
                      style={{ width: '180px', height: '180px', textAlign: 'center'}}
                  />
                  </Col> 
                  <hr/>
                </Row>
                <Row>
                  <Col><p style={{textAlign: 'center', fontSize: '25px'}}>{t('moreThan18years')}</p></Col>
                </Row>
                <Row>
                  <Navbar expand="lg" className="bg-body-white">
                  <Nav className="mx-auto">
                    {/* <Nav.Link onClick={() => {i18n.changeLanguage('es')}}>ESP</Nav.Link>
                    <Nav.Link onClick={() => {i18n.changeLanguage('en')}}>ENG</Nav.Link> 
                    <Nav.Link onClick={() => {i18n.changeLanguage('zh')}}>ZH</Nav.Link> */}
                    <Navbar.Brand onClick={() => {i18n.changeLanguage('es')}}>
                      <img
                        alt=""
                        src={flagEsp}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                      />{' '}
                      ESP
                    </Navbar.Brand> 
                    <Navbar.Brand onClick={() => {i18n.changeLanguage('en')}}>
                      <img
                        alt=""
                        src={flagUsa}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                      />{' '}
                      ENG
                    </Navbar.Brand> 
                    <Navbar.Brand onClick={() => {i18n.changeLanguage('zh')}}>
                      <img
                        alt=""
                        src={flagChina}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                      />{' '}
                      ZH
                    </Navbar.Brand> 
                  </Nav>
                  </Navbar>
                </Row>
              </Container>
            </Modal.Body>
            <Modal.Footer style={{alignContent: 'center'}}>
              <Button variant="primary" onClick={handleClose}>{t('yes')}</Button>
              <Button variant="secondary">
              {t('no')}
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
       
    ); 
}

export default ModalWelcome;